import { Country } from '../../models/country';
import { CustomerStatus } from '../../models/customer/status';

export const InitAction = {
    SetInitial: 'SET_INITIAL',
    SetLiffReady: 'SET_LIFF_READY',
    SetCountries: 'SET_COUNTRIES',
    SetCustomerStatus: 'SET_CUSTOMER_STATUS',
};

export interface SetInitial {
    type: typeof InitAction.SetInitial,
    value: {
        userStatus: number,
        translations: {[key:string]: string},
    },
}

export interface SetLiffReady {
    type: typeof InitAction.SetLiffReady,
    value: {
        userId: string,
        name: string,
        lineLiffId: string,
    },
}

export interface InitSetCountries {
    type: typeof InitAction.SetCountries,
    value: {
        countries: Country[],
    },
}

export interface SetCustomerStatus {
    type: typeof InitAction.SetCustomerStatus,
    value: {
        customerStatus: CustomerStatus,
    },
}

export type InitActions =
    SetInitial |
    SetLiffReady |
    InitSetCountries |
    SetCustomerStatus;
